import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Deliveryorder from "./delivery-orders";
import { useLocation } from "react-router-dom";
import DeliveryPayments from "./delivery-payments";
import { consoleLog } from "../../../utils/log-utils";
import { useDispatch, useSelector } from "react-redux";
import { dbInfoData, updateDBInfo, updateStoreInfo } from "../../../redux/slice/formUpdateSlice";
import { useEffect } from "react";

function UniqueDelivery() {
  const location = useLocation();
  const dbInfo = useSelector(dbInfoData);
  const dispatch=useDispatch();
  const locationData = location.state != null ? location.state : dbInfo;
 consoleLog("location data",locationData)
  const dbId = locationData !== null ? locationData.db.id : ""
  const event = locationData !== null ? locationData.db.event : ""
  const data = locationData !== null ? locationData.db : ""
  consoleLog("data", data);
  useEffect(() => {
    dispatch(updateDBInfo({ dbInfo: locationData }))
  },[locationData])
  return (
    <>
      <main className="container-fluid dashboard">
        <div className="row m-3">
          <div className="col-6">
            <h3 className="dashboard-title">{data.name}</h3>
            <h4 className="dashboard-title">{data.city}</h4>
          </div>
          <div className="col-12 mt-3">
            <Tabs
              defaultActiveKey={event}
              id="uncontrolled-tab-example"
              className=""
            >
              <Tab eventKey="dbOrders" title="Orders">
                <Deliveryorder id={dbId} />
              </Tab>
              <Tab eventKey="dbPayments" title="Settlements">
                <DeliveryPayments id={dbId} />
              </Tab>

            </Tabs>
          </div>
        </div>
      </main>
    </>
  )

}
export default UniqueDelivery;